export default [
	{
		path: 'manage-subscription/cancel-reason',
		name: 'manage-subscription-cancel-reason',
		component: () => import('@/views/account/manage-subscription/CancelReason.vue'),
		meta: {
			requiresAuth: true,
			requiresUser: true,
		},
	},

	{
		path: 'manage-subscription/try-again-in-the-future',
		name: 'manage-subscription-try-again-in-the-future',
		component: () => import('@/views/account/manage-subscription/TryAgainInTheFuture.vue'),
		meta: {
			requiresAuth: true,
			requiresUser: true,
		},
	},

	{
		path: 'manage-subscription/offer-creating',
		name: 'manage-subscription-offer-creating',
		component: () => import('@/views/account/manage-subscription/OfferCreating.vue'),
		meta: {
			requiresAuth: true,
			requiresUser: true,
		},
	},

	{
		path: 'manage-subscription/offer',
		name: 'manage-subscription-offer',
		component: () => import('@/views/account/manage-subscription/offers/Offer.vue'),
		meta: {
			requiresAuth: true,
			requiresUser: true,
		},
	},

	{
		path: 'manage-subscription/one-time-offer-reactivation',
		name: 'one-time-offer-reactivation',
		component: () => import('@/views/account/manage-subscription/offers/Offer.vue'),
		props: {
			predefinedComponentName: 'OneTimeOfferForever',
		},
		meta: {
			requiresAuth: true,
			requiresUser: true,
		},
	},

	{
		path: 'manage-subscription/five-dollar-offer-forever',
		name: 'manage-subscription-five-dollar-offer-forever',
		component: () => import('@/views/account/manage-subscription/offers/Offer.vue'),
		props: {
			predefinedComponentName: 'FiveDollarOfferForever',
		},
		meta: {
			requiresUser: true,
		},
	},

	{
		path: 'manage-subscription/one-year-offer',
		name: 'manage-subscription-one-year-offer',
		component: () => import('@/views/account/manage-subscription/offers/OneYearOffer.vue'),
		meta: {
			requiresUser: true,
		},
	},

	{
		path: 'plan-management',
		name: 'plan-management',
		component: () => import('@/views/account/manage-subscription/PlanManagement.vue'),
		meta: {
			requiresAuth: true,
			requiresUser: true,
		},
	},
	{
		path: 'plan-management/pause-subscription',
		name: 'pause-subscription',
		component: () => import('@/views/account/manage-subscription/PauseSubscription.vue'),
		meta: {
			requiresAuth: true,
			requiresUser: true,
		},
	},
	{
		path: 'plan-management-commitment',
		name: 'plan-management-commitment',
		component: () => import('@/views/account/manage-subscription/PlanManagementCommitment.vue'),
		meta: {
			requiresAuth: true,
			requiresUser: true,
		},
	},
	{
		path: 'plan-management/cancellation-fee',
		name: 'plan-management-cancellation-fee',
		props: { scenarioId: 'cancellationFee' },
		component: () => import('@/views/account/manage-subscription/cancellation/CancellationFee.vue'),
		meta: {
			requiresAuth: true,
			requiresUser: true,
		},
	},
	{
		path: 'plan-management/switch-plan',
		name: 'plan-management-switch-plan',
		props: { scenarioId: 'switchPlan' },
		component: () => import('@/views/account/manage-subscription/cancellation/CancellationFee.vue'),
		meta: {
			requiresAuth: true,
			requiresUser: true,
		},
	},
	{
		path: 'plan-management/downgrade',
		name: 'plan-management-downgrade',
		component: () => import('@/views/account/manage-subscription/cancellation/Downgrade.vue'),
		props: {
			scenarioId: 'downgrade',
		},
		meta: {
			requiresAuth: true,
			requiresUser: true,
		},
	},
	{
		path: 'plan-management/downgrade-before-cancel',
		name: 'plan-management-downgrade-before-cancel',
		component: () => import('@/views/account/manage-subscription/cancellation/Downgrade.vue'),
		props: {
			scenarioId: 'downgrade-before-cancel',
		},
		meta: {
			requiresAuth: true,
			requiresUser: true,
		},
	},
	{
		path: 'plan-management/keep-downgrade',
		name: 'plan-management-keep-downgrade',
		component: () => import('@/views/account/manage-subscription/KeepDowngrade.vue'),
		meta: {
			requiresAuth: true,
			requiresUser: true,
		},
	},
	{
		path: 'plan-management/plan-actions',
		name: 'plan-management-plan-actions',
		component: () => import('@/views/account/manage-subscription/PlanActions.vue'),
		meta: {
			requiresAuth: true,
			requiresUser: true,
			pageAnalyticUxEvent: {
				name: 'ScreenView',
				data: {
					title: 'CANCELLATION_OPTION_SCREEN',
				},
			},
		},
	},
	{
		path: 'plan-management/reminder-success',
		name: 'plan-management-reminder-success',
		component: () => import('@/views/account/manage-subscription/ReminderSuccess.vue'),
		meta: {
			requiresAuth: true,
			requiresUser: true,
			pageAnalyticUxEvent: {
				name: 'ScreenView',
				data: {
					title: 'CANCELLATION_REMINDER_ACTIVATED_SCREEN',
				},
			},
		},
	},
	{
		path: 'plan-management/warm-up-video',
		name: 'plan-management-warm-up-video',
		component: () => import('@/views/account/manage-subscription/WarmUpVideo.vue'),
		meta: {
			requiresAuth: true,
			requiresUser: true,
			pageAnalyticUxEvent: {
				name: 'ScreenView',
				data: {
					title: 'WARMUP_BEFORE_WINBACK_OFFER_SCREEN',
				},
			},
		},
	},
	{
		path: 'manage-subscription/rating',
		name: 'manage-subscription-rating',
		component: () => import('@/views/account/manage-subscription/RatingView.vue'),
		meta: {
			requiresAuth: true,
			requiresUser: true,
		},
	},
	{
		path: 'manage-subscription/post-cancellation-gift',
		name: 'manage-subscription-post-cancellation-gift',
		component: () => import('@/views/account/manage-subscription/PostCancellationGift.vue'),
		meta: {
			requiresAuth: true,
			requiresUser: true,
		},
	},
]
